export default {
  en: {
    finish: 'Finish',
    close: 'Close',
    processing: 'Processing...',
  },
};
